export default __webpack_public_path__ + "static/media/Didot_Bold_Italic.8b4d57e1.ttf";